import MainLayout from "@/components/layout/company/MainLayout.vue";
import axios from "axios";

export default {
    name: "companyResumeDetail",
    
    components: {
        MainLayout
    },

    data() {
        return {
            resume: {
                id: "",
                name: "",
                path: "",
                nrc_number: "",
                nationality: "",
                religion: "",
                phone_number: "",
                email: "",
                facebook: "",
                linkin: "",
                gender: "",
                marital_status: "",
                date_of_birth: "",
                contact_address: "",
                permanent_address: "",
                position: "",
                expected_salary: "",
                education_detail: "",
                other_certificate: "",
                experience_detail: ""
            }
        };
    },

    methods: {
        getResumeDetail() {
            axios.get("/applicant/resume/detail/" + this.$route.params.id)
                .then(response => {
                    if (!response.data || !response.data.id) {
                        this.$router.push({ name: "notFound" });
                        return;
                    }
                    this.resume = response.data;
                })
                .catch(error => {
                    console.log("Resume Detail API error:::::>", error.response ? error.response.data : error);
                    this.$router.push({ name: "notFound" });
                });
        }
    },

    mounted() {
        this.getResumeDetail();
    }
};